export const MinusIcon = () => {
    return (
        <svg width="15" height="2" viewBox="0 0 15 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.62508 1.99878L6.37324 2L6.37187 1.99878L1.12673 1.99723C0.814279 1.99834 0.533182 1.88601 0.329275 1.70528C0.125365 1.52455 -0.00111297 1.27562 7.38201e-06 0.998565C7.38201e-06 0.446872 0.504179 0 1.12661 0L6.37498 1.8752e-07L6.37373 0L8.62688 0.00165524H8.62508L13.8735 0.00165497C14.4959 0.00165497 15 0.448527 15 1.00021C15 1.55191 14.4959 1.99878 13.8735 1.99878H8.62508Z" fill="var(--primary)"></path>
        </svg>
    );
}